import { render, staticRenderFns } from "./detailTable12.vue?vue&type=template&id=19232c00&scoped=true&"
import script from "./detailTable12.vue?vue&type=script&lang=js&"
export * from "./detailTable12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19232c00",
  null
  
)

export default component.exports